<template>
  <div class="mt-3">
    <div class="row">
      <div class="col-12 col-md-4">
        <div class="p-3 rounded bg-greyish-green">
          <div class="row">
            <div class="col-8 pr-0">
              <custom-dropdown
                v-model="selectedAcademicYear"
                fieldkey="id"
                fieldname="name"
                :options="academicyears"
                placeholder="Seleccione el año"
              />
            </div>
            <div class="col">
              <action-button
                i="fas fa-search"
                text="Buscar"
                variant="success w-100"
                @click="onSearch"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <icon-view
      class="my-3 icon-view-color-text"
      icon="far fa-history color-orange p-5"
      icon-size="1.5rem"
      title="Historial de PEI"
      variant="icon-view-extended"
    />
    <div v-if="peiHistoryData.length > 0" class="search-result mt-3">
      <pei-history-row
        v-for="row in peiHistoryData"
        :key="`${row.peiIdFormatted}`"
        ref="pei"
        :has-saee10-report="row.hasSaee10Report"
        :value="row"
        @getReportsPEIPS="getReportsPEIPS(row)"
        @getReportsPEIPSFromStorage="getReportsPEIPSFromStorage(row)"
      />
      <pagination
        v-if="pagination.totalItemCount > pagination.perPage"
        :data="pagination"
        :page-size="pagination.perPage"
        @pagination-go-page="onPageChanged"
      />
    </div>
  </div>
</template>
<script>
import CustomDropdown from 'custom-drop-down';
import ActionButton from '@/components/common/ActionButton';
import IconView from 'icon-view';
import Pagination from 'pagination';
import PeiHistoryRow from './PeiHistoryRow';

import generalService from '@/modules/app/api';
import {
  getRecordHistoryFilterOptions,
  getStudentPeiHistory,
} from '@/modules/shared/studentreferral.api';

export default {
  name: 'RecordPeiHistory',
  components: {
    CustomDropdown,
    ActionButton,
    IconView,
    Pagination,
    PeiHistoryRow,
  },
  props: {
    studentId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      academicyears: [],
      selectedAcademicYear: null,
      peiHistoryData: [],
      pagination: {
        perPage: 10,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
    };
  },
  watch: {
    studentId: {
      handler: function(value) {
        if (value) {
          this.getAcademicYears();
          this.getStudentPEI();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async getAcademicYears() {
      if (this.studentId == undefined && this.studentId == null) return;
      const { data: academicYearsList } = await getRecordHistoryFilterOptions(
        this.studentId
      );
      this.academicyears = academicYearsList;
    },
    async getStudentPEI() {
      const year =
        this.selectedAcademicYear != null ? this.selectedAcademicYear.id : 0;
      if (this.studentId != undefined && this.studentId != null) {
        const { data } = await getStudentPeiHistory({
          studentSieId: this.studentId,
          year,
          pageNumber: this.pagination.currentPage,
          pageSize: this.pagination.perPage,
        }).catch((err) =>
          this.ShowToast('', err.response.data.message, 'error')
        );
        this.peiHistoryData = data.data;
        this.pagination = {
          ...this.pagination,
          totalItemCount: data.totalItemCount,
          pageCount: data.pageCount,
          currentPage: data.currentPage,
          count: data.count,
        };
      }
    },
    async onSearch() {
      this.pagination.currentPage = 1;
      await this.getStudentPEI();
    },
    async onPageChanged(currentPage) {
      this.pagination.currentPage = currentPage;
      await this.getStudentPEI();
    },
    async getReportsPEIPS(item) {
      const peiId = item.peiIdFormatted.replace('-', '');
      await generalService.getReportsPEIPS(peiId).catch((err) => {
        this.ShowToast('', err.response.data.message, 'error');
      });
    },
    async getReportsPEIPSFromStorage(item) {
      if (item.signedPeiAttachmentId) {
        return generalService
          .downloadDocumentByAttachmentId(item.signedPeiAttachmentId)
          .catch((err) => {
            this.ShowToast('', err.response.data.message, 'error');
          });
      } else this.getReportsPEIPS(item);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .icon-view-extended {
    margin-bottom: 0.5rem;
    .dot {
      margin-right: 0.5rem !important;
      width: 40px !important;
      height: 40px !important;
      .title-icon {
        margin: 0 !important;
      }
    }
    .font-16.color-gray-7 {
      font-size: 24px !important;
    }
  }
}

.bg-greyish-green {
  background-color: #f4f6f3;
}
</style>
